import { useEffect, useRef } from "react";
import crypto from "crypto-js";
import Axios from "axios";
import { API_BASE_URL } from "../environment";

// Function to load script and append in DOM tree.
const loadScript = (src) =>
  new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      console.error("razorpay loaded successfully");
      resolve(true);
    };
    script.onerror = () => {
      console.error("error in loading razorpay");
      resolve(false);
    };
    document.body.appendChild(script);
  });

const RenderRazorpay = ({ orderId, amount, submitButton }) => {
  const paymentId = useRef(null);
  const paymentMethod = useRef(null);
  let rzp1;
  const RazorKey = "rzp_test_5Aa5XzzY9f7Sna";

  // To load razorpay checkout modal script.
  const displayRazorpay = async (options) => {
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      console.error("Razorpay SDK failed to load. Are you online?");
      return;
    }
    // All information is loaded in options which we will discuss later.
    rzp1 = new window.Razorpay(options);

    // If you want to retreive the chosen payment method.
    rzp1.on("payment.submit", (response) => {
      // paymentMethod.current = response.method;
      console.error("Payment", response);
    });

    // To get payment id in case of failed transaction.
    rzp1.on("payment.failed", (response) => {
      paymentId.current = response.error.metadata.payment_id;
    });

    // to open razorpay checkout modal.
    rzp1.open();
  };

  // informing server about payment
  const handlePayment = async (status, orderDetails = {}) => {
    await Axios.post(`${API_BASE_URL}/payment`, {
      status,
      orderDetails,
    });
  };

  // we will be filling this object in next step.
  const options = {
    key: RazorKey, // key id from props
    amount,
    currency: "INR",
    name: "Paybia Finance", // Title for your organization to display in checkout modal
    // image, // custom logo  url
    order_id: orderId, // order id from props
    // This handler menthod is always executed in case of succeeded payment
    handler: (response) => {
      console.error(response);
      paymentId.current = response.razorpay_payment_id;
      const keySecret = RazorKey;
      if (!keySecret) {
        console.error("Razorpay Secret Key is missing!");
        return;
      }

      try {
        const succeeded =
          crypto
            .HmacSHA256(
              `${orderId}|${response.razorpay_payment_id}`,
              "smyqvt8bTqQ4vWTmhXxoJFdM"
            )
            .toString() === response.razorpay_signature;
        if (succeeded) {
          if (rzp1) {
            rzp1.close();
          }
          submitButton && submitButton();
        } else {
          console.error("Signature verification failed!");
        }
      } catch (error) {
        console.error("Error in HmacSHA256:", error);
      }
    },
    modal: {
      ondismiss: false, // Close handler to reset the state on modal close
    },
  };

  useEffect(() => {
    displayRazorpay(options);
  }, []);

  return null;
};

export default RenderRazorpay;
